import React, { memo, useEffect, useState } from 'react';
import { Box, Button, Card, Typography } from '@mui/material';
import { DocumentNode, LinkedRtp, RealtaDocument } from '../../../types/RealtaDocument';
import References from './References';
import ReferencedBy from './ReferencedBy';
import { documentService } from '../../../services/DocumentService';

const Graph = React.lazy(() => import('./Graph'));

const GraphView: React.FC<{
  document: RealtaDocument;
  node: DocumentNode;
  size: { width: number; height: number };
}> = ({ size, node, document }) => {
  const [linkedRtps, setLinkedRtps] = useState<LinkedRtp[]>([]);

  useEffect(() => {
    const init = async () => {
      const linkedRtps = await documentService.getLinkedRtp(node.uuid);
      setLinkedRtps(linkedRtps);
    };

    init();
  }, [node]);

  const formatDescription = (description: string) => {
    const formattedDesc = description.replace(/^"|"$/g, '');
    return formattedDesc.charAt(0).toUpperCase() + formattedDesc.slice(1);
  };

  return (
    <Box
      boxShadow={5}
      height="100%"
      p={1}
      sx={{
        overflowY: 'auto',
        '::-webkit-scrollbar': {
          display: 'none',
        },
      }}
    >
      <Graph size={{ width: size.width, height: size.height * 0.7 }} node={node} document={document} />
      {linkedRtps.length > 0 && (
        <Card sx={{ p: 2, mx: 1, mt: 1 }}>
          <Typography variant="h6" fontWeight="bold" mb={2}>
            Regulatory Touch Points
          </Typography>
          {linkedRtps.map((linkedRtp, i) => (
            <Button
              key={i}
              color="inherit"
              href={`${process.env.RTP_ENDPOINT}/rtp/${linkedRtp.name}`}
              target="_blank"
              sx={{
                display: 'block',
                textTransform: 'none',
                fontWeight: 'normal',
                textDecoration: 'underline !important',
                overflow: 'hidden',
                textOverflow: 'hidden',
                mb: 0.5,
              }}
            >
              {formatDescription(linkedRtp.description)}
            </Button>
          ))}
        </Card>
      )}

      <Box display="flex" flexDirection="column">
        <References documentNode={node} />
        <ReferencedBy documentNode={node} />
      </Box>
    </Box>
  );
};
export default memo(GraphView);
